if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Inline-sizes mode: the sizes are shown inline, so the submit button is
        // a real "Add to cart" and must stay that way after a successful add —
        // never flip it back to the "Select size" opener.
        const inlineSizes = !!(this.closest('product-info') || document).querySelector(
          'variant-radios.variant-radios--inline-mode'
        );

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              // Si el modal de tallas (móvil) se cerró antes del submit y este
              // falla (típicamente inventario alcanzado por la cantidad ya en
              // carrito), el usuario no ve nada y la página parece pillada.
              // Abrimos el cart drawer para dar feedback visual del estado
              // actual del carrito.
              if (this.cart && typeof this.cart.open === 'function') {
                if (window.innerWidth < 768) this.cart.classList.add('slide-from-bottom');
                this.cart.open(this.submitButton);
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // Prysm handles the cart drawer — do NOT redirect.
              // Reset the button to "select size" state (skip in inline-sizes
              // mode, where the button is a real "Add to cart").
              if (this.submitButton && !inlineSizes) {
                this.submitButton.classList.add('open-sizes');
                const btnSpan = this.submitButton.querySelector('span:not(.atc-spinner)');
                if (btnSpan) btnSpan.textContent = this.submitButton.dataset.gatedLabel || 'Select size';
              }
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    // Mark the submit button as having opened sizes after successful add
                    if (this.submitButton && !inlineSizes) {
                      this.submitButton.classList.add('open-sizes');
                      const span = this.submitButton.querySelector('span:not(.atc-spinner)');
                      if (span && !span.textContent.trim()) span.textContent = this.submitButton.dataset.gatedLabel || 'Select size';
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              // Mark the submit button as having opened sizes after successful add
              if (this.submitButton && !inlineSizes) {
                this.submitButton.classList.add('open-sizes');
                const span = this.submitButton.querySelector('span:not(.atc-spinner)');
                if (span && !span.textContent.trim()) span.textContent = this.submitButton.dataset.gatedLabel || 'Select size';
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.classList.remove('atc--loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}